module.exports = __webpack_public_path__ + "img/PNIgray.ea0b62e9.svg";